"use strict";
'app public';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const methods = {
  props: {},
  status(props) {
    // let props = this.props;
    if (!props.user || !props.buffer) {
      return '';
    }
    return props.user.typingStatus(props.buffer.name).status;
  }
};
var _default = exports.default = {
  props: {
    user: Object,
    buffer: Object
  },
  m: methods
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
window._app_exports["components"]["TypingStatusIndicator"]
window._app_exports.components.TypingStatusIndicator = exports.default ? exports.default : exports;
